import { gql } from "apollo-boost"

export const updateEquipmentAttachment = gql`
  mutation updateEquipmentAttachment($id: ID!, $data: CreateEquipmentAttachmentInput!) {
    UpdateEquipmentAttachment(id: $id, data: $data)
  }
`